import "./App.css";
import { AuthProvider } from "./components/contexts/AuthContext";
import { CartProvider } from "./components/contexts/CartContext";
import { GeneralProvider } from "./components/contexts/GeneralContext";
import { SubscriptionProvider } from "./components/contexts/SubscriptionContext";
import { ToastProvider } from "./components/contexts/ToastContext";
import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <>
      <AuthProvider>
        <GeneralProvider>
          <CartProvider>
            <ToastProvider>
              <SubscriptionProvider>
                <AppRoutes />
              </SubscriptionProvider>
            </ToastProvider>
          </CartProvider>
        </GeneralProvider>
      </AuthProvider>
    </>
  );
}

export default App;
